module.exports = __webpack_public_path__ + "static/team_03-48eac009318a920517d4801a865ad0fd.png";